import { RestApi, RestResponse } from '@maverick/http';
import { SourceApps } from '@maverick/entity';

const bbiResponseMiddleware = (response: RestResponse) => {
    if (!response.error) {
        if (!!response.body.error) {
            const newResponse: RestResponse = {
                ...response,
                error: true,
                errorMessage: response.body.error,
            };
            return newResponse;
        }

        return response;
    }

    if (response.errorClient) {
        const newResponse: RestResponse = {
            ...response,
            errorMessage: response.body.error,
        };
        return newResponse;
    }

    const newResponse: RestResponse = {
        ...response,
        errorMessage: 'Failure in communicate with the server',
    };

    return newResponse;
};

export const createApiClient = (sourceApp: SourceApps) => {
    let baseUrl: string = '';
    switch (sourceApp) {
        case SourceApps.order:
            baseUrl = '/order/api/bbi';
            break;

        case SourceApps.catering:
            baseUrl = '/catering/api/bbi';
            break;

        case SourceApps.cms:
            baseUrl = '/api/bbi';
            break;

        default:
            baseUrl = '/api/bbi';
            break;
    }

    return new RestApi(baseUrl, undefined, bbiResponseMiddleware);
};
